import { FiberManualRecord } from '@mui/icons-material';
import { Box, List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Images from '../../../utils/Images';
import { useNavigate } from 'react-router-dom';

const SubscriptionFailure = () => {
    const [sub, setSub] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const raw = localStorage.getItem('subscriptionPurchaseData');
        if (raw) {
            setSub(JSON.parse(raw));
            localStorage.removeItem('subscriptionPurchaseData');
        }
    }, []);

    if (!sub) {
        return <div>Loading subscription details...</div>;
    }

    return (
        <Box className="subscriptionPurchase">
            <Box padding={2}>
                <img style={{ width: '100%' }} src={sub.banner_imageUrl} />
            </Box>
            <img style={{ width: '100%' }} src={Images.subDetailBanner} />

            <Box padding={2}>
                <Typography className='title'>{sub?.title}</Typography>
                <Typography className='description' >{sub?.description}</Typography>

                {sub?.subscriptionWorking?.length > 0 && (
                    <>
                        <Typography className='workTitle'>How does it work?</Typography>
                        <Typography className='workPoints'>After you purchase this subscription</Typography>
                    </>
                )}
                <List dense>
                    {sub?.subscriptionWorking?.map((item, index) => (
                        <ListItem key={index} sx={{ alignItems: 'center', py: 0.5 }}>
                            <ListItemIcon
                                sx={{
                                    minWidth: '24px',
                                    display: 'flex',
                                    alignItems: 'center', // vertical center
                                    justifyContent: 'center', // horizontal center if needed
                                    mt: -1, // ensure no vertical offset
                                }}
                            >
                                <FiberManualRecord sx={{ fontSize: 8, color: '#858585' }} />
                            </ListItemIcon>
                            <ListItemText
                                primaryTypographyProps={{ sx: { fontSize: 14 } }}
                                className="workPoints"
                                primary={item}
                            />
                        </ListItem>
                    ))}
                </List>
                {sub?.termsConditions?.length > 0 && (
                    <Typography className='workTitle'>Terms & Conditions</Typography>
                )}
                <List dense>
                    {sub?.termsConditions?.map((item, index) => (
                        <ListItem key={index} sx={{ alignItems: 'center', py: 0.5, m: 0 }}>
                            <ListItemIcon
                                sx={{
                                    minWidth: '24px',
                                    display: 'flex',
                                    alignItems: 'center', // vertical center
                                    justifyContent: 'center', // horizontal center if needed
                                    mt: -1, // ensure no vertical offset
                                }}
                            >
                                <FiberManualRecord sx={{ fontSize: 8, color: '#858585' }} />
                            </ListItemIcon>
                            <ListItemText
                                primaryTypographyProps={{ sx: { fontSize: 14, m: 0, p: 0 } }}
                                className="workPoints"
                                primary={item}
                            />
                        </ListItem>
                    ))}
                </List>
            </Box>
            <Box
                onClick={() => navigate('/subscriptions')}
                sx={{
                    borderRadius: 0,
                    bgcolor: '#DE385B',
                    px: 5,
                    py: 1,
                    borderRadius: '40px',
                    textTransform: 'none',
                    color: '#fff',
                    textAlign: 'center'
                }}
            >
                Go back to buy
            </Box>
        </Box>
    )
}

export default SubscriptionFailure;
